<div class="teams-sidebar-wrapper">
  @if (isSelectedMemberFetching$ | async) {
    <div class="notify-msg animate-pulsating-border">
      <div class="icon-logo-box-hex"></div>
    </div>
  }
  @if (!(isSelectedMemberFetching$ | async)) {
    <span (click)="currentPage = currentPage - 1" class="pb-3 flex">
      @if (currentPage > TEAM_MANAGEMENT_SIDEBAR_PAGES.FIRST_PAGE) {
        <app-arrow-button>
          <div class="text-navy-600 font-semibold text-sm">{{ sidebarTitle$ | async | titlecase }}</div>
        </app-arrow-button>
      } @else {
        <div class="text-navy-600 font-semibold text-sm">{{ sidebarTitle$ | async | titlecase }}</div>
      }
    </span>
    <div class="teamsForm">
      <!--    todo, eventually each form could be a different component-->
      <form
        name="firstPageForm"
        role="form"
        class="form w-100"
        #firstPageForm="ngForm"
        [ngClass]="{ hidden: currentPage !== TEAM_MANAGEMENT_SIDEBAR_PAGES.FIRST_PAGE }"
      >
        @if (currentPage === TEAM_MANAGEMENT_SIDEBAR_PAGES.FIRST_PAGE) {
          <div class="page-container">
            <ng-scrollbar
              #firstPageScroll
              class="std-scrollbar"
              appearance="native"
              orientation="vertical"
              [ngClass]="{ expanded: firstPageScroll.isVerticallyScrollable() }"
            >
              <div class="scrollable-content">
                <app-floating-input
                  label="First Name"
                  name="FirstName"
                  [(ngModel)]="model.first_name"
                  [required]="true"
                  [disabled]="isCurrentUserEdited || !!(getSelectedMember$ | async)?.user_id"
                ></app-floating-input>
                <app-floating-input
                  label="Last Name"
                  name="LastName"
                  [disabled]="isCurrentUserEdited || !!(getSelectedMember$ | async)?.user_id"
                  [(ngModel)]="model.last_name"
                  [required]="true"
                ></app-floating-input>
                <app-floating-input
                  label="Position Title"
                  name="position"
                  [(ngModel)]="model.position"
                  [required]="true"
                ></app-floating-input>
                <app-floating-input
                  label="Email"
                  name="email"
                  type="email"
                  [(ngModel)]="model.email"
                  [disabled]="isCurrentUserEdited || viewType === TEAM_MANAGEMENT_SIDEBAR_VIEW.EDIT_TEAM_MEMBER"
                  required
                ></app-floating-input>
                <app-dropdown
                  [(ngModel)]="model.home_base_id"
                  (ngModelChange)="propertyChanged($event)"
                  [options]="properties$ | async"
                  [required]="true"
                  name="homeBase"
                  placeholder="Home Base"
                  label="Home Base"
                  optionLabel="name"
                  optionValue="id"
                >
                </app-dropdown>
                <app-dropdown
                  [required]="true"
                  [options]="roles$ | async"
                  [(ngModel)]="model.role"
                  (ngModelChange)="handleTemplatesLimit()"
                  [disabled]="isCurrentUserEdited || !(roles$ | async).length"
                  class="capitalize"
                  name="role"
                  placeholder="Authority"
                  label="Authority"
                >
                </app-dropdown>
                <div [ngClass]="{ hidden: isCurrentUserEdited }" class="flex items-center gap-2 my-6">
                  <app-checkbox
                    name="limit_to_templates"
                    class="small"
                    [binary]="true"
                    [(ngModel)]="model.limit_to_templates"
                    [disabled]="model.role === ROLE_TYPE.SPECTATOR"
                    [ngClass]="{ 'p-disabled': model.role === ROLE_TYPE.SPECTATOR }"
                  ></app-checkbox>
                  <span class="text-[13px] text-navy-900 font-semibold"
                    >Team member cannot use their own templates</span
                  >
                  <span
                    appTooltip="If the box is checked, the user will be restricted to using only the templates you have created on your projects, and not any templates from their account."
                    tooltipPosition="bottom"
                    tooltipStyleClass="team-template-tooltip"
                    class="question-icon"
                  ></span>
                </div>
              </div>
            </ng-scrollbar>
          </div>
        }
      </form>
      <form
        name="secondPageForm"
        role="form"
        class="form w-100"
        #secondPageForm="ngForm"
        [ngClass]="{ hidden: currentPage !== TEAM_MANAGEMENT_SIDEBAR_PAGES.SECOND_PAGE }"
      >
        @if (currentPage === TEAM_MANAGEMENT_SIDEBAR_PAGES.SECOND_PAGE) {
          <div class="page-container">
            <app-search-input class="block" (searchText)="filterProperties($event)"></app-search-input>
            <div (click)="allPropertyChecked = !allPropertyChecked" class="team-management-item">
              <app-checkbox
                type="square"
                #allPropCheckbox
                (click)="$event.stopPropagation()"
                (onChange)="allPropertiesCheckboxChanged($event.checked)"
                class="text-xs"
                [binary]="true"
                [ngModel]="allPropertyChecked"
                [ngModelOptions]="{ standalone: true }"
              >
              </app-checkbox>
              <span class="text-size_xl text-navy-900 font-semibold">Select All Properties</span>
            </div>
            <ng-scrollbar
              #propertyScroll
              class="std-scrollbar"
              appearance="native"
              orientation="vertical"
              [ngClass]="{ expanded: propertyScroll.isVerticallyScrollable() }"
            >
              <div class="scrollable-content">
                @for (property of filteredProperties$ | async; track property.id) {
                  <div (click)="propertyCheckbox.updateModel(!propertyCheckbox.checked())" class="team-management-item">
                    <app-checkbox
                      type="square"
                      #propertyCheckbox
                      (click)="$event.stopPropagation()"
                      (onChange)="propertyCheckboxChanged($event.checked, property)"
                      [binary]="true"
                      [ngModel]="getCheckedProperties(property.id) | async"
                      [ngModelOptions]="{ standalone: true }"
                    >
                    </app-checkbox>
                    <div class="flex flex-col">
                      <span class="text-size_xl text-navy-900 font-semibold">{{ property.name }}</span>
                      <span class="text-size_l text-navy-700 font-normal">{{ property.address }}</span>
                    </div>
                  </div>
                }
              </div>
            </ng-scrollbar>
          </div>
        }
      </form>
      <form
        name="thirdPageForm"
        role="form"
        class="form w-100"
        #thirdPageForm="ngForm"
        [ngClass]="{
          hidden: currentPage !== TEAM_MANAGEMENT_SIDEBAR_PAGES.LAST_PAGE
        }"
      >
        @if (currentPage === TEAM_MANAGEMENT_SIDEBAR_PAGES.LAST_PAGE) {
          <div class="page-container">
            <app-search-input class="block" (searchText)="filterProjects($event)"></app-search-input>
            <div (click)="allProjectsCheckbox.updateModel(!allProjectsCheckbox.checked())" class="team-management-item">
              <app-checkbox
                type="square"
                #allProjectsCheckbox
                (click)="$event.stopPropagation()"
                (onChange)="allProjectsCheckboxChanged(allProjectsCheckbox.checked())"
                class="text-xs"
                [binary]="true"
                [ngModel]="areAllProjectCheckboxesSelected$ | async"
                [ngModelOptions]="{ standalone: true }"
              >
              </app-checkbox>
              <span class="text-size_xl text-navy-900 font-semibold">Select All Projects</span>
            </div>
            <ng-scrollbar
              #projectScroll
              class="std-scrollbar"
              appearance="native"
              orientation="vertical"
              [ngClass]="{ expanded: projectScroll.isVerticallyScrollable() }"
            >
              <div class="scrollable-content">
                @for (property of selectedProperties$ | async; track property.id) {
                  @for (project of property.projects; track project.id) {
                    <div (click)="checkboxProj.updateModel(!checkboxProj.checked())" class="team-management-item">
                      <app-checkbox
                        type="square"
                        #checkboxProj
                        (click)="$event.stopPropagation()"
                        (onChange)="projectCheckboxChanged(checkboxProj.checked(), project)"
                        class="text-xs"
                        [binary]="true"
                        [ngModel]="getCheckedProjects(project.id) | async"
                        [ngModelOptions]="{ standalone: true }"
                      >
                      </app-checkbox>
                      <div class="flex flex-col">
                        <span class="text-size_xl text-navy-900 font-semibold">{{ project.title }}</span>
                        <span class="text-size_m text-navy-700 font-normal">{{ property.name }}</span>
                      </div>
                    </div>
                  }
                }
              </div>
            </ng-scrollbar>
            <div class="team-management-item border-0">
              <app-checkbox [binary]="true" [(ngModel)]="model.share_future_projects"> </app-checkbox>
              <span class="text-size_l text-navy-900 font-semibold">Allow Access Future Projects</span>
              <span
                appTooltip="If the box is checked, any future project added to the property will be automatically shared with this user."
                tooltipPosition="bottom"
                tooltipStyleClass="team-template-tooltip"
                class="question-icon"
              ></span>
            </div>
          </div>
        }
      </form>
    </div>
    <div class="flex justify-end">
      @if (currentPage !== TEAM_MANAGEMENT_SIDEBAR_PAGES.LAST_PAGE && !isCurrentUserEdited) {
        <app-simple-button (click)="incrementPage()">Next </app-simple-button>
      } @else {
        <app-simple-button [wrapperClass]="{ 'bg-yellow-500': true }" (click)="handleSave()">
          {{ viewType === TEAM_MANAGEMENT_SIDEBAR_VIEW.ADD_TEAM_MEMBER ? 'Add Teammate' : 'Save' }}
        </app-simple-button>
      }
    </div>
  }
</div>
